import React, { FC, ReactNode } from 'react';
import { PayFitColor } from '../../types/module';
import { CardContent } from '../CardContent';
import { CardType } from '../CardContent/logic';
import { TagProps } from '../Tag';
import { classNames } from '../../../../growth-platform-brand-system-v2/src/utils/style';

export interface MenuCardProps {
  title: string;
  subtitle: string;
  tags?: TagProps[];
  capsText?: string;
  image?: ReactNode;
  imageBgColor?: PayFitColor;
}

export const MenuCard: FC<MenuCardProps> = ({
  title,
  subtitle,
  tags,
  capsText = '',
  image,
}) => {
  return (
    <div
      className={classNames(
        'MenuCard flex flex-col md:flex-row rounded-[20px]',
        'overflow-hidden',
        'bg-[#F7F9FC]',
      )}
    >
      {image && (
        <div
          className={classNames(
            'h-[169px] xl:aspect-[200/169] overflow-hidden',
          )}
        >
          {image}
        </div>
      )}
      <div className="flex-auto xl:max-w-[337px] pl-24 pb-12 xl:pl-16 pr-32 xl:pr-0 xl:py-24">
        <CardContent
          cardType={CardType.MenuCard}
          title={title}
          subtitle={subtitle}
          tags={tags}
          capsText={capsText}
          TitleTag="div"
        />
      </div>
    </div>
  );
};
